import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {AuthService} from '../service/auth.service';
import {Router} from '@angular/router';
import {catchError} from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor{
    constructor(
        private auth: AuthService,
        private route: Router
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if(this.auth.isAutheniticate()){
            req = req.clone({
                headers: new HttpHeaders({
                    'Content-Type':  'application/json',
                    Authorization: `Bearer ${this.auth.token}`
                }),
                setParams: {
                    json: '1'
                }
            });
        }
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                console.log('[interceptor Error]:', error);
                if(error.status === 403){
                    this.auth.logout();
                    this.route.navigate(['login'],{
                         queryParams: {
                            authFailed: true
                         }
                    });
                }
                return throwError(error);

            })
        );
    }

}
